import { render, staticRenderFns } from "./HekimTanimlama.vue?vue&type=template&id=2f0b247e&scoped=true&class=ozel-bg&"
import script from "./HekimTanimlama.vue?vue&type=script&lang=js&"
export * from "./HekimTanimlama.vue?vue&type=script&lang=js&"
import style0 from "./HekimTanimlama.vue?vue&type=style&index=0&id=2f0b247e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b247e",
  null
  
)

export default component.exports